import { useTranslate } from "~/ur-react-hooks"

export interface GeneratorHelpButtonProps {
  onClick: () => void
}

const GeneratorHelpButton: React.FC<GeneratorHelpButtonProps> = ({
  onClick,
}) => {
  const translations = useTranslate({
    tooltip: "onboarding.tour.help-button.tooltip",
  })

  return (
    <button
      type="button"
      onClick={onClick}
      title={translations.tooltip}
      className="flex items-center justify-center w-7 h-7 rounded-full bg-gray-100 hover:bg-primary hover:text-white text-gray-500 transition-colors text-sm font-bold"
      aria-label={translations.tooltip}
    >
      ?
    </button>
  )
}

export default GeneratorHelpButton
